export default __webpack_public_path__ + "static/media/removeformat.b38231ae.svg";